import React from "react";
import T from "prop-types";
import moment from "moment";
import { DAYS, MONTH } from "APP_ROOT/constants";
import DateRangePicker from "react-bootstrap-daterangepicker";

function SimpleDateRangePicker({ handleDateChange, defaultLast30Days = true }) {
  return (
    <DateRangePicker
      initialSettings={{
        startDate:
          defaultLast30Days &&
          moment()
            .subtract(29, DAYS)
            .toDate(),
        endDate: defaultLast30Days && moment().toDate(),
        ranges: {
          Today: [moment().toDate(), moment().toDate()],
          Yesterday: [
            moment()
              .subtract(1, DAYS)
              .toDate(),
            moment()
              .subtract(1, DAYS)
              .toDate()
          ],
          "Last 7 Days": [
            moment()
              .subtract(6, DAYS)
              .toDate(),
            moment().toDate()
          ],
          "Last 30 Days": [
            moment()
              .subtract(29, DAYS)
              .toDate(),
            moment().toDate()
          ],
          "This Month": [
            moment()
              .startOf(MONTH)
              .toDate(),
            moment()
              .endOf(MONTH)
              .toDate()
          ],
          "Last Month": [
            moment()
              .subtract(1, MONTH)
              .startOf(MONTH),
            moment()
              .subtract(1, MONTH)
              .endOf(MONTH)
          ]
        }
      }}
      onCallback={handleDateChange}
    >
      <span className="input-group-btn">
        <button type="button" className="btn btn-success ">
          <i className="fa fa-calendar" />
          &nbsp;
          <span>Select Date</span> <i className="fa fa-caret-down" />
        </button>
      </span>
    </DateRangePicker>
  );
}

SimpleDateRangePicker.propTypes = {
  defaultLast30Days: T.bool,
  handleDateChange: T.func.isRequired
};

export default SimpleDateRangePicker;



// WEBPACK FOOTER //
// ./app/modules/shared/components/SimpleDateRangePicker/SimpleDateRangePicker.jsx